import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getMoreCommentLoading: false,
  getMoreCommentFailed: false,
  getMoreCommentReject: false,
  getMoreCommentMessage: [],
  moreComment: [],

  getMyCommentsLoading: false,
  getMyCommentsFailed: false,
  getMyCommentsReject: false,
  getMyCommentsMessage: [],
  MyComments: [],

  postNewCommentLoading: false,
  postNewCommentFailed: false,
  postNewCommentReject: false,
  postNewCommentMessage: [],

  getCafeIsSuitableForListLoading: false,
  getCafeIsSuitableForListFailed: false,
  getCafeIsSuitableForListReject: false,
  getCafeIsSuitableForListMessage: [],
  cafeIsSuitableForList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_MORE_CAFE_COMMENT_LOADING: {
      return {
        ...state,
        getMoreCommentLoading: true,
        getMoreCommentFailed: false,
        getMoreCommentReject: false,
        getMoreCommentMessage: [],
        moreComment: [],
      };
    }
    case actionTypes.GET_MORE_CAFE_COMMENT_SUCCESS: {
      return {
        ...state,
        getMoreCommentLoading: false,
        getMoreCommentFailed: false,
        getMoreCommentReject: false,
        getMoreCommentMessage: [],
        moreComment: action.payload.cafes,
      };
    }
    case actionTypes.GET_MORE_CAFE_COMMENT_FAILED: {
      return {
        ...state,
        getMoreCommentLoading: false,
        getMoreCommentFailed: true,
        getMoreCommentReject: false,
        getMoreCommentMessage: [],
        moreComment: [],
      };
    }
    case actionTypes.GET_MORE_CAFE_COMMENT_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getMoreCommentLoading: false,
        getMoreCommentFailed: false,
        getMoreCommentReject: true,
        getMoreCommentMessage: message,
        moreComment: [],
      };
    }

    case actionTypes.GET_MY_COMMENTS_LOADING: {
      return {
        ...state,
        getMyCommentsLoading: true,
        getMyCommentsFailed: false,
        getMyCommentsReject: false,
        getMyCommentsMessage: [],
        MyComments: [],
      };
    }
    case actionTypes.GET_MY_COMMENTS_SUCCESS: {
      return {
        ...state,
        getMyCommentsLoading: false,
        getMyCommentsFailed: false,
        getMyCommentsReject: false,
        getMyCommentsMessage: [],
        MyComments: action.payload,
      };
    }
    case actionTypes.GET_MY_COMMENTS_FAILED: {
      return {
        ...state,
        getMyCommentsLoading: false,
        getMyCommentsFailed: true,
        getMyCommentsReject: false,
        getMyCommentsMessage: [],
        MyComments: [],
      };
    }
    case actionTypes.GET_MY_COMMENTS_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getMyCommentsLoading: false,
        getMyCommentsFailed: false,
        getMyCommentsReject: true,
        getMyCommentsMessage: message,
        MyComments: [],
      };
    }

    case actionTypes.POST_NEW_COMMENT_LOADING: {
      return {
        ...state,
        postNewCommentLoading: true,
        postNewCommentFailed: false,
        postNewCommentReject: false,
        postNewCommentMessage: [],
      };
    }
    case actionTypes.POST_NEW_COMMENT_SUCCESS: {
      return {
        ...state,
        postNewCommentLoading: false,
        postNewCommentFailed: false,
        postNewCommentReject: false,
        postNewCommentMessage: [],
      };
    }
    case actionTypes.POST_NEW_COMMENT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        postNewCommentLoading: false,
        postNewCommentFailed: true,
        postNewCommentReject: false,
        postNewCommentMessage: message,
      };
    }
    case actionTypes.POST_NEW_COMMENT_REJECT: {
      return {
        ...state,
        postNewCommentLoading: false,
        postNewCommentFailed: false,
        postNewCommentReject: true,
        postNewCommentMessage: [],
      };
    }

    case actionTypes.GET_MORE_CAFE_COMMENT_LOADING: {
      return {
        ...state,
        getCafeIsSuitableForListLoading: true,
        getCafeIsSuitableForListFailed: false,
        getCafeIsSuitableForListReject: false,
        getCafeIsSuitableForListMessage: [],
        cafeIsSuitableForList: [],
      };
    }
    case actionTypes.GET_CAFE_SUITABLE_FOR_LIST_SUCCESS: {
      return {
        ...state,
        getCafeIsSuitableForListLoading: false,
        getCafeIsSuitableForListFailed: false,
        getCafeIsSuitableForListReject: false,
        getCafeIsSuitableForListMessage: [],
        cafeIsSuitableForList: action.payload,
      };
    }
    case actionTypes.GET_CAFE_SUITABLE_FOR_LIST_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        getMoreCommentLoading: false,
        getMoreCommentFailed: true,
        getMoreCommentReject: false,
        getMoreCommentMessage: message,
        moreComment: [],
      };
    }
    case actionTypes.GET_CAFE_SUITABLE_FOR_LIST_REJECT: {
      return {
        ...state,
        getMoreCommentLoading: false,
        getMoreCommentFailed: false,
        getMoreCommentReject: true,
        getMoreCommentMessage: [],
        moreComment: [],
      };
    }

    default:
      return state;
  }
};
